<template>
  <LayoutContent>
    <h2 class="text-h5 secondary--text font-weight-bold text-capitalize">{{ subcategory }}</h2>
    <div v-if="loading" class="text-center" style="margin-top: 20%">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <div v-if="brands.length > 0" class="mb-8" :class="$vuetify.breakpoint.lgAndUp ? 'mt-5' : 'mt-0'">
        <v-chip
          :class="[
            'mr-3 font-weight-bold elevation-2',
            $route.query.brand === brand.name.toLowerCase() ? 'white--text primary lighten-1' : 'white primary--text text--darken-1',
            !$vuetify.breakpoint.lgAndUp ? 'my-1' : ''
          ]"
          v-for="(brand, index) in brands"
          :key="index"
          @click="
            $router.replace({
              name: $constants.ROUTE_NAME.PRODUCT_CATEGORY,
              params: { category: category.toLowerCase() },
              query: { subcategory: subcategory.toLowerCase(), brand: brand.name.toLowerCase() }
            })
          "
        >
          {{ brand.name }}
        </v-chip>
      </div>
      <div v-if="products.length > 0">
        <v-row v-if="products[0].product_category_id !== 7">
          <v-col v-for="product in products" :key="product.id" :xs="6" :sm="3" :md="3" :lg="2" :xl="2" :cols="6">
            <item :productInfo="product"></item>
          </v-col>
          <v-col v-if="role === 'Member' && isPartnerDeal" :xs="12" :sm="7" :lg="5">
            <AgentBanner @join="showPartnerDialog = true" />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col class="px-0 py-0" v-for="item in products" :key="item.id" :xs="12" :sm="6" :md="6" :lg="4" :xl="3">
            <vouchers-ticket
              :currency="item.currency"
              :productId="item.id"
              :voucherTitle="item.product_name"
              :voucherValue="item.voucher_value"
              :discountPercentage="item.discount_percentage"
              :voucherDiscountPrice="item.discounted_price"
              :voucherRetailPrice="item.unit_price"
              :voucherPartnerPrice="item.agent_price ? Number(item.agent_price) : 0"
              :voucherType="item.voucher_category"
              :isAvailable="item.voucher_can_buy"
            />
          </v-col>
        </v-row>
      </div>
      <div v-else class="ma-16 text-h6 font-weight-medium grey--text text-center">{{ category !== 'vouchers' ? $t('label.noProductListed') : $t('label.noVoucherListed') }}</div>
    </div>
    <BecomeAgentDialog v-if="showPartnerDialog === true" v-model="showPartnerDialog" />
  </LayoutContent>
</template>

<script>
import Item from '@/components/product/Item.vue'
import VouchersTicket from '@/views/Vouchers/VouchersTicket'
import LayoutContent from '../layouts/LayoutContent.vue'
import AgentBanner from '@/components/agent/Banner.vue'
import BecomeAgentDialog from '@/components/storefront/BecomeAgentDialog.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CategoryProducts',
  components: {
    Item,
    LayoutContent,
    VouchersTicket,
    AgentBanner,
    BecomeAgentDialog
  },
  data: () => ({
    loading: '',
    category: '',
    subcategory: '',
    brand: '',
    products: [],
    brands: [],
    isPartnerDeal: false,
    showPartnerDialog: false
  }),
  mounted() {
    console.log('CATEGORY PRODUCTS', this.$route.params.category)
    this.fetchProducts()
  },
  watch: {
    $route() {
      this.fetchProducts()
    }
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    role() {
      return this.currentUser ? this.currentUser.roles : 'Member'
    }
  },
  methods: {
    ...mapActions('page', ['getShopData']),
    fetchProducts() {
      this.products = []
      this.category = this.$route.params.category
      this.subcategory = this.$route.query.subcategory
      this.brand = this.$route.query.brand ? this.$route.query.brand : 'all'
      this.loading = true
      this.getShopData({
        category: this.category,
        subcategory: this.subcategory,
        brand: this.brand
      })
        .then((res) => {
          let index = res.category.findIndex((f) => f.name.toLowerCase() === this.category)
          if (index > -1 && res.category[index].id === 17) this.isPartnerDeal = true
          else this.isPartnerDeal = false
          this.brands = res.brand
          this.products = res.products
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
